import { Control, FieldValues, Path, RegisterOptions, useController } from 'react-hook-form';
import { NameSearchDropdown, NameSearchOption } from './NameSearchDropdown';

type FormsNameSearchDropdownProps<FData extends FieldValues> = {
  control: Control<FData>;
  nameField: Path<FData>;
  idField: Path<FData>;
  label: string;
  useSearch: (query: string) => { options: NameSearchOption[]; isFetching: boolean };
  rules?: RegisterOptions<FData>;
  errorText?: string;
  placeholder?: string;
};

export const FormsNameSearchDropdown = <FData extends FieldValues>(
  props: FormsNameSearchDropdownProps<FData>,
) => {
  const nameController = useController({
    control: props.control,
    name: props.nameField,
    rules: props.rules,
  });
  const idController = useController({ control: props.control, name: props.idField });

  return (
    <NameSearchDropdown
      label={props.label}
      value={(nameController.field.value as string) ?? ''}
      onValueChange={nameController.field.onChange}
      selectedId={idController.field.value as number | null | undefined}
      onSelectedIdChange={idController.field.onChange}
      useSearch={props.useSearch}
      errorText={props.errorText}
      placeholder={props.placeholder}
    />
  );
};
